var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-pulse fa-lg fa-fw"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }